import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import LoadingButton from "@mui/lab/LoadingButton";
import { useRef, useState } from 'react';
import api from '../../Apis';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

export default function UploadImageFromDevice(props) {
    const { t ,i18n, } = useTranslation();
    const selectFile = (e) => {
        inputFile.current.click();
    }
    const inputFile = useRef(null);
    const [state, setState] = useState({
        loading: false
    })

    const onChangeFile = (e) => {
        const file = e.target.files;
        if (file.length > 0) {
            setState({
                ...state,
                loading: true
            })
            const formData = new FormData();
            for (var i = 0; i < file.length; i++) {
                formData.append('file[]', file[i]);
            }
            formData.append('fanpage_id', props.fanpage_id);
            formData.append('lang', i18n.language);
            formData.append('type', 'right_away');
            formData.append('folder_id', props.folder_selected.folder_id);
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + props.cookie
                },
                body: formData,
            };
            fetch(api.upload_attachment, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.success == true) {
                        const image_selected = [];
                        result.datas.map((item) => {
                            image_selected.push({
                                'mime_type': "image/jpeg",
                                'file_url': null,
                                'video_data': null,
                                'image_data': item.link,
                                'code': item.code,
                                'is_delete': true
                            })
                        })
                        props.sendImageRightAway(image_selected);
                    } else if (result.success == false && result.type == 'validate') {
                        if (result.errors.length > 0) {
                            var string_error = '';
                            result.errors.map((value, key) => {
                                string_error = string_error + '<p>' + value + '</p>';
                            })
                            Swal.fire({
                                title: string_error,
                                icon: 'warning',
                                confirmButtonText: t("common.exit")
                            })
                        }
                    } else if (result.success == false && result.type == 'error') {
                        Swal.fire({
                            title: result.message,
                            icon: 'error',
                            confirmButtonText: t("common.exit")
                        })
                    }
                    setState({
                        ...state,
                        loading: false
                    })
                }
            )
        }
    }

    return (
        <LoadingButton
            loading={state.loading}
            onClick={selectFile}
            color="secondary"
            sx={{marginRight: '20px'}}
            variant="outlined" startIcon={<UploadRoundedIcon />}>
            {t("common.upload.sendImageFromDevice")}
            <input style={{display: 'none'}} ref={inputFile} onChange={onChangeFile} multiple type="file" className='file'/>
        </LoadingButton>
    )
}